import { AuthStatus } from 'types/auth';

// MSAL returns its redirect response in the fragment, for example #code=... or #error=...
const RESPONSE_FRAGMENT = /(^|&)(code|id_token|error)=/;

/*
True while this load is carrying an authentication response.

MSAL clears the fragment as it processes the response, so this has to be sampled before
handleRedirectPromise runs. Its intermediate hop can also resolve without an account while it is
still navigating back to the launch URL, and that load is unresolved rather than signed out.
*/
export const hasRedirectResponse = (hash: string): boolean =>
  RESPONSE_FRAGMENT.test(hash.replace(/^#/, ''));

export interface AuthStatusInput {
  readonly hasAccount: boolean;
  readonly hasRedirectResponse: boolean;
  readonly signInIsOwed: boolean;
}

/*
Decide what the session can honestly claim about itself.

Only the absence of every possibility counts as signed out. An automatic sign-in that has not run
yet, or a response still being processed, means the answer is not known, and reporting that as
signed out is what puts a Sign In button in front of a user who is midway through a handoff.
*/
export const resolveAuthStatus = ({ hasAccount, hasRedirectResponse: responsePresent, signInIsOwed }: AuthStatusInput): AuthStatus => {
  if (hasAccount) return 'signedIn';
  if (responsePresent || signInIsOwed) return 'resolving';
  return 'signedOut';
};
